'use es6';

import UrlRegexFactory from './factories/UrlRegexFactory';
var URL_REGEX = UrlRegexFactory();
export default URL_REGEX;